// extracted by mini-css-extract-plugin
export default {"date":"TimePost_date__yH8y4"};